import { Box, Row, Text } from '~/commonComponents';

interface ITitleProps {
  color: string;
  title: string;
  count?: number;
}

export const Title = ({ color, count = 0, title }: ITitleProps) => (
  <Row alignItems="stretch">
    <Box backgroundColor={color} borderRadius={4} marginRight={8} width={4} />
    <Text bold fontSize={18}>
      {title} ({count}):
    </Text>
  </Row>
);
